"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _queryString = _interopRequireDefault(require("query-string"));
var _reactRouterDom = require("react-router-dom");
var _EntitlementService = require("cornerstone_ui_core/lib/services/EntitlementService");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class CallBackHandler extends _react.default.Component {
  render() {
    const values = _queryString.default.parse(this.props.location.search);
    localStorage.removeItem("sessionId");
    if (values) {
      localStorage.setItem("sessionId", values.sessionId);
      localStorage.removeItem("loginModalOpen");
      if (values.encodedCacheKey) localStorage.setItem("jwttknkey", values.encodedCacheKey);else if (values.jwttknkey) localStorage.setItem("jwttknkey", values.jwttknkey);
    }
    if (values.redirect) return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
      to: values.redirect
    });else return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
      to: this.props.defaultRoute
    });
  }
}
var _default = exports.default = (0, _reactRouterDom.withRouter)(CallBackHandler);